import { FormDialogTemplate } from "../../../../../../../shared/form-dialog/form-dialog.template";
import { Output, Injector, EventEmitter } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { PartListService } from "../../../part-list.service";
import { CgpAlertDialogComponent } from "../../../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.component";
import { LoadingMethodService } from "../../../../../phf.service";
import { PartLoadingTabComponent } from "../part-loading-tab.component";
import { PartDetailService } from "../../part-detail.service";

export class LoadingMethodDialogTemplate extends FormDialogTemplate {

    dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
    editformworker: any;
    alertDialog: CgpAlertDialogComponent;

    constructor(
        readonly injector: Injector,
        private readonly partDetailService: PartDetailService,
        private readonly partListService: PartListService,
        private readonly partLoadingTabComponent: PartLoadingTabComponent,
        private readonly partLoadingMethodService: LoadingMethodService
    ) {
        super();
        this.partLoadingMethodService.read("", true);
        const formbuilder = injector.get(FormBuilder);
        const editform = formbuilder.group(
            {
                LoadingMethod: [],
                Method: []
            }
        );
        this.editformworker = editform;
        this.initilize("- " + partLoadingTabComponent.part.Code, editform, this.formDialogTabs);
    }

    cancel = () => {
        this.partLoadingTabComponent.partDetailComponent.isVisDialog = true;
        this.partListService.closeDialog();
        this.partLoadingTabComponent.isOpen = true;
        this.partLoadingTabComponent.displayFunction();
    }
    save = ({ dataItem }): void => {
        this.partListService.closeDialog();
        this.partLoadingTabComponent.isOpen = true;
        this.partLoadingTabComponent.displayFunction();
        this.partLoadingTabComponent.partDetailComponent.isVisDialog = true;
        this.partLoadingTabComponent.partLoadingTabSave = false;
        this.partLoadingTabComponent.setLoadingValue(dataItem.LoadingMethod);
    }
    clicked = (dataItem: any) => {
        const textAreaValue = this.editformworker.get("LoadingMethod").value;
        if (dataItem === undefined) {
            //do nothing
        } else if (textAreaValue != null) {
            this.editformworker.get("LoadingMethod").setValue(textAreaValue + dataItem);
        } else {
            this.editformworker.get("LoadingMethod").setValue(dataItem);
        }
    }

    formControls = [
        {
            type: "combobox",
            name: "Method",
            title: "Method",
            service: this.partLoadingMethodService,
            valueField: "Description",
            textField: "Description",
            onChange: this.clicked,
            stretch: true,
        },
        {
            type: "textarea",
            rows: 4,
            name: "LoadingMethod",
            title: "Loading Method Note",
            stretch: true,
        }
    ]
    formDialogTabs = [
        {
            title: "Loading Method",
            selected: true,
            formControls: this.formControls
        },
    ]

}
